// extracted by mini-css-extract-plugin
module.exports = {"row":"row___3LEvc","trash-wrap":"trash-wrap___1s45z","trash":"trash___1Kz4L","selection-wrap":"selection-wrap___3g94U","selection":"selection___3xQKq"};